import React from "react";

import { Icon, IconProps } from "../";

export const ArrowUpwardIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.4697 12.0303C17.7626 12.3232 18.2374 12.3232 18.5303 12.0303C18.8232 11.7374 18.8232 11.2626 18.5303 10.9697L12.5303 4.96967C12.2374 4.67678 11.7626 4.67678 11.4697 4.96967L5.46967 10.9697C5.17678 11.2626 5.17678 11.7374 5.46967 12.0303C5.76256 12.3232 6.23744 12.3232 6.53033 12.0303L11.25 7.31066V18.75C11.25 19.1642 11.5858 19.5 12 19.5C12.4142 19.5 12.75 19.1642 12.75 18.75V7.31066L17.4697 12.0303Z"
      />
    </Icon>
  );
};
